// src/hook/useFinance.js
import React, { useCallback, useState } from 'react';
import {
  getSalesApi, createSaleApi, updateSaleApi, deleteSaleApi,
  getSalePaymentsApi, addPaymentToSaleApi,
  getFinanceMetricsApi,  
} from '../api/finance';
import { useAuth } from './';

export function useFinance() {
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const [sales, setSales]       = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [metrics, setMetrics]   = useState(null);

  const [expenseCategories, setExpenseCategories] = useState([]);

  const { auth } = useAuth();

  /* ===== Sales ===== */
  const getSales = async (params) => {
    try {
      setLoading(true);
      const data = await getSalesApi(auth.token, params);
      setSales(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err);
      console.error(err);
    }
  };

  const newSale = async (payload) => {
    try {
      setLoading(true);
      const data = await createSaleApi(payload, auth.token);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const editSale = async (id, payload) => {
    try {
      setLoading(true);
      const data = await updateSaleApi(id, payload, auth.token);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const removeSale = async (id) => {
    try {
      setLoading(true);
      await deleteSaleApi(id, auth.token);
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  const getPaymentsBySale = async (saleId) => {
    try {
      const data = await getSalePaymentsApi(saleId, auth.token);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  const addPayment = async (saleId, payload) => {
    try {
      const data = await addPaymentToSaleApi(saleId, payload, auth.token);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

 
  /* ===== Metrics ===== */
  const getFinanceMetrics = async (params) => {
    try {
      const data = await getFinanceMetricsApi(auth.token, params);
      setMetrics(data);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  return {
    loading, error,
    sales, getSales, newSale, editSale, removeSale,
    expenses, metrics, getFinanceMetrics,
    expenseCategories, 
    getPaymentsBySale, addPayment,
  };
}
